
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class AdUserModel extends Model<AdUserModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'givenName', type: 'string' },
		{ name: 'mail', type: 'string' },
		{ name: 'displayName', type: 'string' }
	];
	[key: string]: any;
	
	public id?: string;
	public givenName: string;
	public mail: string;
	public displayName: string;
    
	constructor(){
		super();
		this.id = undefined;
		this.givenName = '';
		this.mail = '';
		this.displayName = '';
		
	}
	getProperties(){
		return AdUserModel.classProperties;
	}
}

